module.exports = __webpack_public_path__ + "img/pp.3352829c.jpg";